import React, { PureComponent } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DraftsHead from './Table/Head';
import Toolbar from './Table/Toolbar';
import { connect } from 'react-redux';
import { Drafts } from '../../../../../services/Drafts';
import { removeDraft, fetchDraftsPaginated } from '../../../../../redux/actions/draftsActions';
import { withRouter } from 'react-router-dom';
import Pagination from '../../../../../shared/components/pagination/Pagination';
import * as moment from 'moment';
import DeleteForeverIcon from 'mdi-react/DeleteForeverIcon';
import EditOutlineIcon from 'mdi-react/EditOutlineIcon';
import {withTranslation} from "react-i18next";
import ConfirmRemoveModal from '../../../../Layout/modals/ConfirmRemoveModal';
import withErrorNotification from '../../../../../hof/withErrorNotification';

const defaultImage = `${process.env.PUBLIC_URL}/img/default.jpg`;

class DraftsTable extends PureComponent {
  state = {
    order: 'desc',
    orderBy: 'updatedAt',
    selected: [],
    page: 1,
    rowsPerPage: 5,
    isConfirmationModalOpened: false,
    draftToRemove: null
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') { order = 'asc'; }

    this.setState({ order, orderBy });

    const blogId = this.props.blog._id;
    this.props.onFetchDrafts(blogId, this.state.page, this.state.rowsPerPage, orderBy, order);
  };

  handleChangePage = (page) => {
    this.setState({ page });
    const blogId = this.props.blog._id;
    this.props.onFetchDrafts(blogId, page, this.state.rowsPerPage, this.state.orderBy, this.state.order);
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  opeRemoveConfirmationModal = (draftId) => {
      this.setState({isConfirmationModalOpened: true, draftToRemove: draftId});
  }

  handleConfirmationModalCancel = () => {
      this.setState({isConfirmationModalOpened: false, draftToRemove: null});
  }

  handleDeleteSelected = async () => {

      return withErrorNotification(async () => {
          const blogId = this.props.blog._id;

          await Drafts.removeDraft(blogId, this.state.draftToRemove);
          // this.props.onRemoveDraft(draftId);
          this.props.onFetchDrafts(blogId, this.state.page, this.state.rowsPerPage, this.state.orderBy, this.state.order);
          this.handleConfirmationModalCancel();
      }, () => {
          this.handleConfirmationModalCancel();
      })

  };

  handlePublishSelected = async () => {

  }

  handleSelectAllClick = async () => {

  }

  handleEditSelected = async (draftId) => {
    this.props.history.push(`/edit/${draftId}`);
  }

  handleScheduleSelected = async () => {

  }

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  createCategoriesNamesList = (ids) => {
    let categories = [];
    for (let id of ids) {
      for (let category of this.props.blog.categories) {
        if (category._id === id) {
          categories.push(category.name);
        }
      }
    }
    return categories;
  }

  render() {
    const {
      order, orderBy, selected
    } = this.state;

    const { t } = this.props;
    return (
        <>
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">{t('posts.drafts.title')}</h5>
              <h5 className="subhead">{t('posts.drafts.subtitle')}</h5>
            </div>
            {this.props.drafts.length ? (
              <>
                <Toolbar
                  numSelected={selected.length}
                  handleDeleteSelected={this.handleDeleteSelected}
                  handlePublishSelected={this.handlePublishSelected}
                  // handleEditSelected={this.handleEditSelected}
                  handleScheduleSelected={this.handleScheduleSelected}
                  onRequestSort={this.handleRequestSort}
                />
                <div className="material-table__wrap">
                  <Table className="material-table">
                    <DraftsHead
                      numSelected={selected.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={this.handleSelectAllClick}
                      onRequestSort={this.handleRequestSort}
                      rowCount={this.props.drafts.length}
                    />
                    <TableBody>
                      {this.props.drafts
                        .map((d) => {
                          const isSelected = this.isSelected(d._id);
                          return (
                            <TableRow
                              className="material-table__row"
                              role="checkbox"
                              aria-checked={isSelected}
                              tabIndex={-1}
                              key={d._id}
                              selected={isSelected}
                            >
                              <TableCell className="material-table__cell" padding="checkbox">
                                <div className="draft_table-img-wrapper">
                                  <img className="draft_table-img" src={ d.thumbnail_image ? d.thumbnail_image : defaultImage} alt="" />
                                </div>
                              </TableCell>
                              <TableCell
                                className="material-table__cell"
                                component="th"
                                scope="row"
                                padding="none">
                                <span>
                                  {d.title}
                                </span>
                              </TableCell>
                              <TableCell className="material-table__cell">
                                {this.createCategoriesNamesList(d.categories).map(category => <span className="tag" key={category}>{category}</span>)}
                              </TableCell>
                              <TableCell className="material-table__cell">
                                {d.tags.map(tag => <span className="tag" key={tag} >{tag}</span>)}
                              </TableCell>
                              <TableCell className="material-table__cell">{d.username}</TableCell>
                              <TableCell className="material-table__cell">{d.scheduled ? moment(d.updatedAt).format('llll') : 'no'}</TableCell>
                              <TableCell className="material-table__cell">{moment(d.updatedAt).format('llll')}</TableCell>
                              <TableCell className="material-table__cell">
                                {/* {d.username === this.props.auth.username && <button className="draft_table-btn" title="Schedule" type="button"><ClockOutlineIcon /></button>} */}
                                {d.username === this.props.auth.username && <button className="draft_table-btn" title={t('posts.drafts.tooltips.remove_draft')} type="button" onClick={() => this.opeRemoveConfirmationModal(d._id)}><DeleteForeverIcon /> </button>}
                                {d.username === this.props.auth.username && <button className="draft_table-btn" title={t('posts.drafts.tooltips.edit_draft')} type="button" onClick={() => this.handleEditSelected(d._id)}><EditOutlineIcon /> </button> }
                                {/* <button className="draft_table-btn" title="Preview on blog" type="button"><OpenInNewIcon /></button> */}
                              </TableCell>
                            </TableRow>
                          );
                        })}

                    </TableBody>
                  </Table>
                </div>
                <Pagination
                itemsCount={this.props.metadata.total}
                itemsToShow={this.props.metadata.limit}
                pageOfItems={this.props.metadata.page + 1}
                onChangePage={this.handleChangePage}
              /></>) : <p>{t('posts.drafts.no_drafts_found')}</p>}
          </CardBody>
        </Card>
      </Col>
    <ConfirmRemoveModal
        onAccept={() => this.handleDeleteSelected()}
        onClose={() => this.handleConfirmationModalCancel()}
        isOpen={this.state.isConfirmationModalOpened} />
        </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    drafts: state.drafts.data,
    metadata: state.drafts.metadata,
    blog: state.blogs.blog,
    auth: state.auth
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onRemoveDraft: (id) => { dispatch(removeDraft(id)) },
    onFetchDrafts: (blogId, page, limit, sortBy, order) => {dispatch(fetchDraftsPaginated(blogId, page, limit, sortBy, order)) }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation('dashboard')(DraftsTable)));
